import styled from 'styled-components';
import { Text } from '../Text';

const StyledContainer = styled.div<{
	$gap: number;
	$iconSize: number;
	$fontSize: number;
	$textOpacity: number;
	$iconOpacity: number;
	$fontWeight: number;
	$textColor: string;
}>`
	display: flex;
	align-items: center;
	column-gap: ${(props) => props.$gap}px;

	img {
		width: ${(props) => props.$iconSize}px;
		height: ${(props) => props.$iconSize}px;
		opacity: ${(props) => props.$iconOpacity};
		user-select: none;
		pointer-events: none;
	}

	${Text} {
		font-size: ${(props) => props.$fontSize}px;
		color: ${(props) => props.$textColor};
		opacity: ${(props) => props.$textOpacity};
		font-weight: ${(props) => props.$fontWeight};
	}
`;

export { StyledContainer };
